import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Accueil from './Containers/Accueil';
import Produit from './Containers/Product';

import About from './Containers/About';
import './Style/Accueil.ObsidianAura.css'; // 1) THEME GLOBAL (variables + overlay)
import './Style/App.css';   

import Offre from './Containers/Produit/Offre';
import TermsOfUse from './Components/TermsOfUse';
import PrivacyPolicy from './Containers/Legal/PrivatePolicy';

import Contact from './Containers/Contact';
import HowItWorks from './Containers/HowItWorks';
import BlogList from './blog/BlogList';
import BlogPost from './blog/BlogPost';
import SecurityPage from './Containers/SecurityPage';
import LifeCompanies from './Containers/LifeCompanies';
import LifeSchool from './Containers/LifeSchool';
import LifeIndividual from './Containers/LifeIndividuals';

function App() {
  return (
    <Suspense fallback={<div>Loading translations...</div>}>
      <Router>
        <Header/>

        {/* ✅ Canvas global Obsidian pour toutes les pages */}
        <div className="life-home">
          <div className="life-home__overlay" />

          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/solution" element={<Produit />} />
            <Route path="/about" element={<About />} />
            <Route path="/offre" element={<Offre />} />
            <Route path="/termes" element={<TermsOfUse />} />
            <Route path="/companies" element={<LifeCompanies />} />
            <Route path="/school" element={<LifeSchool />} />
            <Route path="/you" element={<LifeIndividual />} />
            <Route path="/confidentialite" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/security" element={<SecurityPage />} />
          </Routes>
        <Footer />
      </div>
    </Router>
  </Suspense>
);
}

export default App;
